baseApp.directive('notify', ['$timeout','ngNotify', '$rootScope', function($timeout, ngNotify, $rootScope) {
    return {
        link:function($scope){
            var ERROR_LENGTH = 5000;
            var REGULAR_LENGTH = 2000;
            var FADEOUT_LENGTH = 500;

            $("[data-hide]").on("click", function(){
                $scope.hide();
            });
            $(".ngn-dismiss").on("click", function(){
                //ugly hack sorry - cc2 will soon go away :)
                if($(this).parent().text().includes(endOfLifeNotification)) {
                    $rootScope.endOfLifeShown = true;
                }
            });
            $scope.showAndFade = function(){
                var duration = $rootScope.globalNotification.type == 'error'?ERROR_LENGTH:REGULAR_LENGTH;
                ngNotify.set($rootScope.globalNotification.message, {
                    type: $rootScope.globalNotification.type,
                    duration:duration,
                    sticky: $rootScope.globalNotification.sticky,
                    position: 'top',
                });
                $rootScope.globalNotification = null;
            };
            $scope.hide = function() {
                $(this).closest("." + $(this).attr("data-hide")).hide();
            };
            $scope.show = function() {
                var duration = $rootScope.globalNotification.type == 'error'?ERROR_LENGTH:REGULAR_LENGTH;
                ngNotify.set($rootScope.globalNotification.message, {
                    type: $rootScope.globalNotification.type,
                    duration:duration,
                    sticky: $rootScope.globalNotification.sticky,
                    position: 'top',
                });
            };

            function show(){
                $scope.show();
            }

            function fadeOut(){
                $('.ngn').fadeOut(FADEOUT_LENGTH);
            }

            function showAndFade(){
                $scope.showAndFade();
            }

            var listeners = [];
            listeners.push($rootScope.$on('$saveSuccess', showAndFade));
            listeners.push($rootScope.$on('$saveFail', show));
            listeners.push($rootScope.$on('$hideNotification', fadeOut));

            $scope.$on('$destroy',function() {
                listeners.forEach(function(listener){
                    listener();
                });
            });
        }
    };
}]);
